// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NtPD","footer":"styles_footer__ZwCnt"};